module.exports = __webpack_public_path__ + "img/ai@3x.ff86e405.png";